<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { watch } from 'vue'
import { useFieldArray } from 'vee-validate'
export interface AktivityProjektuProps {}

const props = defineProps<AktivityProjektuProps>()
const { t } = useI18n()

const { push, fields, remove } = useFieldArray('projekt.aktivity')

watch(
  fields,
  () => {
    // Aby pouzivatel videl aspon jeden field group, pushneme pri mounte objekt s prazdnymi hodnotami
    if (fields.value?.length === 0) {
      push({})
    }
  },
  { deep: true, immediate: true }
)
</script>

<template>
  <div v-for="(field, idx) in fields" :key="field.key">
    <IDSKDivider v-if="idx > 0" class="mt-8 mb-8" />
    <IDSKHeading as="h3" variant="s" class="mb-5">
      {{ t('zoppm.step5.activity.heading') }} {{ idx + 1 }}
    </IDSKHeading>

    <ValidationWrapper
      v-slot="slotProps"
      :name="`projekt.aktivity[${idx}].poradie`"
      :value="idx"
    >
      <IDSKInput
        :id="`projekt.aktivity[${idx}].poradie`"
        v-bind="slotProps"
        readonly
        hidden
      />
    </ValidationWrapper>

    <ValidationWrapper v-slot="slotProps" :name="`projekt.aktivity[${idx}].nazov`">
      <IDSKInput
        :id="`projekt.aktivity[${idx}].nazov`"
        v-bind="slotProps"
        :label="t('zoppm.step5.activity.titleFieldLabel')"
        class="mb-2"
      />
    </ValidationWrapper>

    <ValidationWrapper v-slot="slotProps" :name="`projekt.aktivity[${idx}].popis`">
      <IDSKInput
        :id="`projekt.aktivity[${idx}].popis`"
        v-bind="slotProps"
        readonly
        hidden
      />
    </ValidationWrapper>

    <ValidationWrapper
      v-slot="slotProps"
      :name="`projekt.aktivity[${idx}].intervalRealizacie.datumZaciatok`"
    >
      <IDSKDateInputSeparated
        :id="`projekt.aktivity[${idx}].intervalRealizacie.datumZaciatok`"
        :label="t('zoppm.step5.activity.startDateLabel')"
        :hint="t('zoppm.step5.activity.startDateHint')"
        mode="date"
        v-bind="slotProps"
        class="mb-4"
      />
    </ValidationWrapper>

    <ValidationWrapper
      v-slot="slotProps"
      :name="`projekt.aktivity[${idx}].intervalRealizacie.datumKoniec`"
    >
      <IDSKDateInputSeparated
        :id="`projekt.aktivity[${idx}].intervalRealizacie.datumKoniec`"
        :label="t('zoppm.step5.activity.endDateLabel')"
        :hint="t('zoppm.step5.activity.endDateHint')"
        mode="date"
        v-bind="slotProps"
        class="mb-4"
      />
    </ValidationWrapper>

    <div v-if="fields.length > 1" class="activity-remove">
      <IDSKLink
        class="mb-6"
        href="javascript:void(0)"
        no-visited-state
        @click.prevent="remove(idx)"
      >
        {{ t('odstranitAktivitu') }}
      </IDSKLink>
    </div>
  </div>

  <IDSKButton
    variant="secondary"
    class="mb-8"
    :data-test-id="`zoppm-aktivity-pridat`"
    @click="push({})"
  >
    {{ t('pridatAktivitu') }}
  </IDSKButton>
</template>

<i18n lang="yaml">
sk:
  odstranitAktivitu: 'Odstrániť aktivitu'
  pridatAktivitu: 'Pridať ďalšiu aktivitu'
</i18n>
